/**
 * Utils Factory
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('ProductRelatedSvc', productRelatedSvc);

    productRelatedSvc.$inject = [
        'ItxStaticResourceSvc',
        'logger',
        'ngDialog',
        '$rootScope',
        'CmsConfigSvc',
        '$http',
        '$q',
        'timestampSvc',
        'Product',
        'ItxUtilsFct',
        'itxAkamaiSvc',
        'ItxScreenSizeSvc',
        'DUTTI_CONS',
        'CommonServices',
        'imDispatcherService',
        'ItxConstants'
    ];

    function productRelatedSvc(
        ItxStaticResourceSvc,
        logger,
        ngDialog,
        $rootScope,
        CmsConfigSvc,
        $http,
        $q,
        timestampSvc,
        Product,
        ItxUtilsFct,
        itxAkamaiSvc,
        ItxScreenSizeSvc,
        DUTTI_CONS,
        CommonServices,
        imDispatcherService,
        ItxConstants
    ) {
        var _this = this;

        var KEY = 'RECENTLY_VIEWED';
        var cookieGroup = DUTTI_CONS.COOKIE_GROUPS.FUNCTIONAL_PERSONALIZATION;
        var storeId = inditex.iStoreId;
        var daysOfExpiration = '30';
        // _this.staticUrl = inditex.iStoreJSON.details.staticUrl.slice(0, -7);
        _this.staticUrl = ItxStaticResourceSvc.getDomain();
        // _this.staticUrl = 'https://localhost:44300/static';

        _this.similarsUrl = 'https://pro.api-mirror.wide-eyes.it/v4/SearchById';
        _this.recommendationsUrl = 'https://pro.api-mirror.wide-eyes.it/v2/RecommendById';
        _this.config = {
            headers: {
                'Content-Type': 'application/json',
                'apiKey': ItxConstants.wideEyesApiKey
            }
        };

        _this.ts = timestampSvc.getTs();

        _this.minutesExpirationCache = 5;
        _this.relatedCache = {};

        // CLASS ProductUid format json received
        function ProductUid(product) {
            if (product) {
                this.section = product.sectionNameEN ? product.sectionNameEN : undefined;
                this.product_id = product.id ? product.id : product.product_id;
                this.sku = product.sku ? product.sku : undefined; // para mocaco
                this.colorId = getProductColorId(product);
                // this.date = product.date ? product.date : new Date(); TESTING
                this.timestamp = product.timestamp ? product.timestamp : new Date().getTime();
                var skus = [];
                if (product.activeDetail) {
                    _.each(product.activeDetail.colors, function (color) {
                        skus = _.concat(skus, _.map(color.sizes, 'sku'));
                    });
                }
                this.arraySku = skus;
            }
        }

        // CLASS state localstorage
        function NewState() {
            this.storeId = storeId;
            this.products = [];
        }

        function getProductColorId(product) {
            if (product.uid) {
                return product.uid.slice(-3);
            } else if (product.state && product.state.selectedColor) {
                return product.state.selectedColor.id;
            } else {
                return undefined;
            }
        }

        var service = {
            setProductRecentlyViewed: setProductRecentlyViewed,
            getProductsRecentlyViewed: getProductsRecentlyViewed,
            getProductRelated: getProductRelated,
            getCompleteLook: getCompleteLook,
            getProductBuyed: getProductBuyed,
            openPopupRelateds: openPopupRelateds,
            filterProductsByMocaco: filterProductsByMocaco,
            getRelatedProducts: getRelatedProducts,
            //NEW
            getRelatedsCarrouselsToShow: getRelatedsCarrouselsToShow,
            getAmountFromPlace: getAmountFromPlace,
            getFunctionFromPlace: getFunctionFromPlace
        };
        return service;

        function _getFromCache(url, currentDate) {
            const cachePetition = _this.relatedCache[url];

            if (cachePetition && cachePetition.date) {
                const cachePetitionDate = cachePetition.date;
                const timeDiff = currentDate.diff(cachePetitionDate, 'minutes');
                if (timeDiff >= _this.minutesExpirationCache) {
                    _deleteFromCache(url);
                } else {
                    return cachePetition.value;
                }
            }

            return undefined;
        }

        function _addToCache(url, value, currentDate) {
            const cacheObject = {
                value,
                date: currentDate
            };

            _this.relatedCache[url] = cacheObject;
        }

        function _deleteFromCache(url) {
            _.unset(_this.relatedCache, url);
        }

        function getAmountFromPlace(place) {
            let amount;

            const amountsOnPopUps = {
                xs: 2.5,
                others: 4
            };

            const amountOutsidePopUps = {
                xs: 2.5,
                sm: 4,
                md: 5.5,
                lg: 4
            };

            switch (place) {
                case 'CS_BS':
                case 'ADD_CART': {
                    //no hay stock () pop up de añadido a la cesta
                    if (ItxScreenSizeSvc.is('xs')) {
                        amount = amountsOnPopUps.xs;
                    } else {
                        amount = amountsOnPopUps.others;
                    }
                }

                case 'PRODUCT_GRID':
                case 'PRODUCT_DETAIL':
                case 'CART': {
                    // parrilla () ficha () en pantalla de shopcart, cuando tramitemos pedido
                    if (ItxScreenSizeSvc.is('xs')) {
                        amount = amountOutsidePopUps.xs;
                    } else if (ItxScreenSizeSvc.is('sm')) {
                        amount = amountOutsidePopUps.sm;
                    } else if (ItxScreenSizeSvc.is('md')) {
                        amount = amountOutsidePopUps.md;
                    } else if (ItxScreenSizeSvc.is('lg')) {
                        amount = amountOutsidePopUps.lg;
                    }
                }
            }
            return amount;
        }

        function getFunctionFromPlace(place) {
            let action;
            switch (place) {
                case 'CS_BS' || 'ADD_CART' || 'PRODUCT_GRID':
                    action = 'navigateToProduct';
                    break;

                case 'PRODUCT_DETAIL':
                    action = 'changeProductView';
                    break;

                case 'CART':
                    action = 'openPopup';
                    break;

                default:
                    action = 'navigateToProduct';
                    break;
            }
            return action;
        }

        function getRelatedsCarrouselsToShow(place) {
            var deferred = $q.defer();
            if (!place) {
                deferred.resolve([]);
            }
            CmsConfigSvc.getProperty('related_products')
                .then(function (relatedProducts) {
                    const relatedBlock = relatedProducts.find((related) => {
                        return related && place && related.place === place;
                    });
                    let relatedsToShow = [];
                    if (relatedBlock && relatedBlock.related_products) {
                        const carrousels = relatedBlock.related_products;
                        relatedsToShow = carrousels.filter((carrousel) => {
                            return carrousel.visible;
                        });
                    }
                    deferred.resolve(relatedsToShow);
                })
                .catch(function () {
                    deferred.resolve([]);
                });
            return deferred.promise;
        }

        function getRelatedProducts(itemsConfig, baseProduct, excludedProducts, amount) {
            //PRE: el amount sirve para definir el número exacto de productos que queremos. Si le pasamos -1 nos devolverá todos los dels itemsConfig.
            var deferred = $q.defer();
            _getRelatedRecursive(itemsConfig, 0, baseProduct, excludedProducts, amount).then((relatedProducts) => {
                deferred.resolve(relatedProducts);
            });

            return deferred.promise;
        }

        function handleProductsConfiguration(products, type) {
            products.forEach((product) => {
                product.config = {};
                product.config.isNoRollover = true;

                if (type === 'similar') {
                    product.typeRelated = 'RELATED';
                } else if (type === 'completeLook') {
                    product.typeRelated = 'COMPLETE_LOOK';
                } else if (type === 'floren') {
                    product.typeRelated = 'RELATED_BUYED';
                } else if (type === 'recentlyViewed') {
                    product.typeRelated = 'RECENTLY_VIEWED';
                }

                product.setRelated(true);

                // const colorId = product.state.selectedColor.id;
                // const images = ItxUtilsFct.getImageProductUrls( product.activeDetail, colorId || null , 'relatedProduct', 'siluet2', 'grid' );
                // const url = product.getUrl();

                // if( url && images && images.length > 0 ) {
                //     // Cargamos la silueta con fondo blanco
                //     let img = images[0];
                //     if(img && img.indexOf('_5_')){
                //         img = img.replace('_5_', '_4_');
                //     }
                //     product.state.url = url;
                //     product.state.images = {
                //         siluet: itxAkamaiSvc.useAkamaiImage(img, 400)
                //     };
                //     product.setRelated(true);
                // }
            });
        }

        function _getRelatedRecursive(itemsConfig, currentIndex, baseProduct, excludedProducts, amountRemaining) {
            var deferred = $q.defer();

            if (amountRemaining === 0 || currentIndex >= itemsConfig.length) {
                deferred.resolve([]);
                return deferred.promise;
            }

            const currentItemConfig = itemsConfig[currentIndex];

            _getProductsFromItemConfig(currentItemConfig, baseProduct, excludedProducts, amountRemaining).then((products) => {
                if (!products) {
                    products = [];
                }

                handleProductsConfiguration(products, currentItemConfig.type);

                let newRemaining = -1;
                if (amountRemaining !== -1) {
                    newRemaining = amountRemaining - products.length;
                }

                const isLast = currentIndex === itemsConfig.length - 1;

                if ((newRemaining > 0 || newRemaining === -1) && !isLast) {
                    currentIndex++;
                    const newExcluded = excludedProducts.concat(products);
                    _getRelatedRecursive(itemsConfig, currentIndex, baseProduct, newExcluded, newRemaining).then((recursiveProducts) => {
                        handleProductsConfiguration(products, currentItemConfig.type);
                        const finalProducts = products.concat(recursiveProducts);
                        deferred.resolve(finalProducts);
                    });
                } else {
                    deferred.resolve(products);
                }
            });

            return deferred.promise;
        }

        //json -> 1 url
        //stock -> n url   1, 2   /stock/1, /stock/2
        //productos -> n url 1, 2    /product/1, /product/2   -> p = new Product(id, color)   cache .> /product/p.id -> p  -> en la cache gaurdo mocaco -> al new product pasarle un producto en la primera posicion y un color id

        function _getProductsFromItemConfig(itemConfig, baseProduct, excludedProducts, amount) {
            var deferred = $q.defer();

            let amountToFind;
            if (amount === -1 || itemConfig.max <= amount) {
                amountToFind = itemConfig.max;
            } else {
                amountToFind = amount;
            }

            if (amountToFind === 0) {
                return deferred.resolve([]);
            }

            let promises = [];

            if (itemConfig.type === 'similar') {
                promises.push(getFromRelated(baseProduct, excludedProducts, 'similars', amountToFind));
            } else if (itemConfig.type === 'completeLook') {
                promises.push(getFromRelated(baseProduct, excludedProducts, 'recommendations', amountToFind));
            } else if (itemConfig.type === 'floren') {
                promises.push(getFromFloren(baseProduct, excludedProducts, amountToFind));
            } else if (itemConfig.type === 'recentlyViewed') {
                promises.push(getFromRecentlyViewed(excludedProducts, amountToFind));
            }

            if (promises.length > 0) {
                $q.all(promises)
                    .then((data) => {
                        const products = data[0];
                        // const finalProducts = _retrieveAmount(products, amountToFind);
                        _handleItemConfig(itemConfig, products, amountToFind);
                        deferred.resolve(products);
                    })
                    .catch((err) => deferred.resolve([]));
            } else {
                deferred.resolve([]);
            }

            return deferred.promise;
        }

        //floren -> related_buyed
        //vistos recientemiente
        //related -> products_ -> similars
        //completa tu look -> products_ -> recommendations

        function getFromRelated(baseProduct, excludedProducts, type, amountToFind) {
            var deferred = $q.defer();
            if (!baseProduct) {
                logger.logError('GETTING PRODUCTS FROM FLOREN WITH WRONG PARAMETERS');
                deferred.reject();
                return deferred.promise;
            }

            _getRelatedProducts(baseProduct, type)
                .then((florenProducts) => {
                    const florenProductsFiltered = _filterExcluded(florenProducts, excludedProducts);
                    _filterProductsWithStock(florenProductsFiltered)
                        .then((productsWithStock) => {
                            _fetchProducts(productsWithStock, amountToFind).then((fetchedProducts) => {
                                deferred.resolve(fetchedProducts);
                            });
                        })
                        .catch((err) => deferred.reject(err));
                })
                .catch((err) => deferred.reject(err));

            return deferred.promise;
        }

        function _getRelatedProducts(baseProduct, type) {
            var deferred = $q.defer();

            const mocaco = baseProduct.getMocacocode();
            const jsonId = md5(mocaco).slice(-2);
            const ts = _this.ts;

            const endpoint = `${_this.staticUrl}/relateds/products_${jsonId}.json?ts=${ts}`;
            let url;
            if (type === 'similars') {
                url = _this.similarsUrl;
            } else {
                url = _this.recommendationsUrl;
            }

            const data = {
                uid: mocaco,
                country: inditex.iCountryCode.toLowerCase()
            };

            const cachedRelatedJson = _getFromCache(endpoint, moment());

            if (cachedRelatedJson) {
                const relatedProductInfo = cachedRelatedJson;
                let relatedProducts = [];
                if (relatedProductInfo) {
                    if (type === 'similars') {
                        relatedProducts = _getProductUidArray(relatedProductInfo);
                    } else if (type === 'recommendations') {
                        const sortedRecommendedProducts = sortRecommendedOneOfEach(relatedProductInfo);
                        relatedProducts = _getProductUidArray(sortedRecommendedProducts);
                    }
                }
                deferred.resolve(relatedProducts);
            } else {
                $http
                    .post(url, data, _this.config)
                    .then((res) => {
                        let relatedProductInfo = res.data.results;
                        let relatedProducts = [];
                        if (relatedProductInfo) {
                            if (type === 'similars') {
                                relatedProductInfo = relatedProductInfo.map((item) => {
                                    return {
                                        uid: item.uid,
                                        product_id: item.filters.product_ids[0]
                                    };
                                });
                                _addToCache(endpoint, relatedProductInfo, moment());
                                relatedProducts = _getProductUidArray(relatedProductInfo);
                            } else if (type === 'recommendations') {
                                relatedProductInfo = relatedProductInfo.map((item) => {
                                    return {
                                        category: item.category.name,
                                        result: item.similars.map((similar) => {
                                            return {
                                                uid: similar.uid,
                                                product_id: similar.filters.product_ids[0]
                                            };
                                        }),
                                        subcategory: item.category.subcategory.name
                                    };
                                });
                                _addToCache(endpoint, relatedProductInfo, moment());
                                const sortedRecommendedProducts = sortRecommendedOneOfEach(relatedProductInfo);
                                relatedProducts = _getProductUidArray(sortedRecommendedProducts);
                            }
                        }

                        deferred.resolve(relatedProducts);
                    })
                    .catch(function () {
                        console.error('PRODUCTS RELATEDS GET STATIC FILE ERROR');
                        deferred.resolve([]);
                    });
            }

            return deferred.promise;
        }

        function sortRecommendedOneOfEach(arrayRecommendedCategories) {
            //dado el array de categorias de completa tu look, te devuelve un array que empieza con el primero de cada categoria, luego los segundos...
            //si tenemos 3 categorias [A,B,C] con 3 productos cada uno nos devolvería el array [1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C]

            let objectWithSortedInformation = {};
            arrayRecommendedCategories.forEach((category) => {
                category.result.forEach((product, index) => {
                    if (!objectWithSortedInformation[index]) {
                        objectWithSortedInformation[index] = [];
                    }
                    objectWithSortedInformation[index].push(product);
                });
            });

            let sortedProductsArray = [];

            Object.entries(objectWithSortedInformation).forEach((productsOnIndex) => {
                sortedProductsArray = sortedProductsArray.concat(productsOnIndex[1]);
            });

            return sortedProductsArray;
        }

        function getFromFloren(baseProduct, excludedProducts, amountToFind) {
            var deferred = $q.defer();
            if (!baseProduct) {
                logger.logError('GETTING PRODUCTS FROM FLOREN WITH WRONG PARAMETERS');
                deferred.reject();
                return deferred.promise;
            }

            _getFlorenProducts(baseProduct)
                .then((florenProducts) => {
                    const florenProductsFiltered = _filterExcluded(florenProducts, excludedProducts);
                    _filterProductsWithStock(florenProductsFiltered)
                        .then((productsWithStock) => {
                            _fetchProducts(productsWithStock, amountToFind).then((fetchedProducts) => {
                                deferred.resolve(fetchedProducts);
                            });
                        })
                        .catch((err) => deferred.reject(err));
                })
                .catch((err) => deferred.reject(err));

            return deferred.promise;
        }

        function _getFlorenProducts(baseProduct) {
            console.log('AQUI MIIIIIL');
            var deferred = $q.defer();

            const mocaco = baseProduct.getMocacocode();
            const ts = _this.ts;
            const url = `/relateds/related_buyed.json?ts=${ts}`;

            const cachedFlorenJson = _getFromCache(url, moment());

            if (cachedFlorenJson) {
                const florenProductInfo = cachedFlorenJson[mocaco];
                let florenProducts = [];
                if (florenProductInfo) {
                    florenProducts = _getProductUidArray(florenProductInfo.floren);
                }
                deferred.resolve(florenProducts);
            } else {
                $http
                    .get(url)
                    .then((res) => {
                        _addToCache(url, res.data, moment());
                        const florenProductInfo = res.data[mocaco];
                        let florenProducts = [];
                        if (florenProductInfo) {
                            florenProducts = _getProductUidArray(florenProductInfo.floren);
                        }

                        deferred.resolve(florenProducts);
                    })
                    .catch(function () {
                        console.error('PRODUCTS FLOREN GET STATIC FILE ERROR');
                        deferred.resolve([]);
                    });
            }

            return deferred.promise;
        }

        function getFromRecentlyViewed(excludedProducts, amountToFind) {
            var deferred = $q.defer();

            const recentlyViewedProducts = getRecentlyViewedProducts();
            const recentlyProductsFiltered = _filterExcluded(recentlyViewedProducts, excludedProducts);

            _filterProductsWithStock(recentlyProductsFiltered)
                .then((productsWithStock) => {
                    _fetchProducts(productsWithStock, amountToFind).then((fetchedProducts) => {
                        deferred.resolve(fetchedProducts);
                    });
                })
                .catch((err) => deferred.reject(err));

            return deferred.promise;
        }

        function getRecentlyViewedProducts() {
            const recentlyState = getStateRecentlyViewed();
            if (!recentlyState || !recentlyState.products || recentlyState.products.length === 0) {
                return [];
            }

            const stateWithoutExpired = _cleanExpiredProducts(recentlyState);
            setStateRecentlyViewed(stateWithoutExpired);

            const recentlyViewedUidArray = _getProductUidArray(stateWithoutExpired.products);

            return recentlyViewedUidArray;
        }

        function _getProductUidArray(allProducts) {
            let relatedProducts = [];

            const arrayProducts = _filterRepeated(allProducts);

            if (arrayProducts && arrayProducts.length > 0) {
                relatedProducts = _generateProductUidArray(arrayProducts);
            }
            return relatedProducts;
        }

        function _filterRepeated(arrayProductsWithRepeated) {
            let arrayProducts = [];
            arrayProductsWithRepeated.forEach((repeated) => {
                const isRepeated = arrayProducts.find((p) => p.product_id === repeated.product_id) !== undefined;
                if (!isRepeated) {
                    arrayProducts.push(repeated);
                }
            });

            return arrayProducts;
        }

        function _filterExcluded(products, excludedProducts) {
            //PRE: products -> este array debe de haber pasado antes ya por la funcion _generateProductUidArray

            if (!products) {
                return [];
            } else if (!excludedProducts) {
                return products;
            }

            const excludedProductsUid = _generateProductUidArray(excludedProducts);

            return products.filter((product) => {
                return (
                    excludedProductsUid.find((excluded) => {
                        return excluded.product_id === product.product_id;
                    }) === undefined
                );
            });
        }

        function _handleItemConfig(itemConfig, finalProducts, amountAsked) {
            const helper = JSON.parse(JSON.stringify(itemConfig));
            if (itemConfig && finalProducts) {
                if (!itemConfig.max || finalProducts.length < amountAsked) {
                    //si nos llegan menos de los que pedimos, entonces marcamos que ya no quedan para evitar repetir peticiones.
                    itemConfig.max = 0;
                } else {
                    itemConfig.max -= amountAsked;
                }
            }
            itemConfig = JSON.parse(JSON.stringify(helper));
        }

        // function _applyFiltersAndGetAmount(products, amountToFind)

        function _filterProductsWithStock(arrayProducts) {
            var deferred = $q.defer();
            const MAX_STOCK_PETITIONS = 30;
            let arrayIdsProducts = [];
            let stockObject = {};
            arrayProducts.forEach((p) => {
                const url = `/stock/${p.product_id}`;
                const cachedStock = _getFromCache(url, moment());

                if (cachedStock) {
                    stockObject[p.product_id] = cachedStock;
                } else {
                    if (arrayIdsProducts.length < MAX_STOCK_PETITIONS) {
                        arrayIdsProducts.push(p.product_id);
                    }
                }
            });

            if (arrayIdsProducts.length === 0) {
                deferred.resolve(_removeWithoutStock(arrayProducts, stockObject));
            } else {
                joyr.rest
                    .xRestGetProductStock(arrayIdsProducts)
                    .done(function (productStocks) {
                        productStocks.forEach((productStock) => {
                            const url = `/stock/${productStock.productId}`;
                            _addToCache(url, productStock, moment());
                            stockObject[productStock.productId] = productStock;
                        });

                        deferred.resolve(_removeWithoutStock(arrayProducts, stockObject));
                    })
                    .Catch((err) => deferred.reject(err));
            }

            return deferred.promise;
        }

        function _removeWithoutStock(arrayProducts, stockObject) {
            const productsAvailable = arrayProducts.filter((p) => {
                let isAvailable = false;
                const productStock = stockObject[p.product_id];

                if (productStock && productStock.stocks && productStock.stocks.length > 0) {
                    isAvailable =
                        productStock.stocks.find((s) => {
                            return s.availability === 'in_stock';
                        }) !== undefined;
                }

                return isAvailable;
            });

            return productsAvailable;
        }

        function _fetchArrayProducts(productUidArray) {
            var deferred = $q.defer();

            let promises = [];
            productUidArray.forEach((pui) => {
                promises.push(_fetchSingleProduct(pui));
            });

            if (promises.length === 0) {
                deferred.resolve([]);
            } else {
                $q.all(promises).then((data) => {
                    const allProducts = Object.values(data);
                    const fetchedProducts = allProducts.filter((product) => {
                        return product !== undefined;
                    });
                    deferred.resolve(fetchedProducts);
                });
            }

            return deferred.promise;
        }

        function _fetchSingleProduct(productUid) {
            var deferred = $q.defer();

            if (!productUid) {
                deferred.resolve(undefined);
                return deferred.promise;
            }

            const url = `/product/${productUid.product_id}`;

            const cachedProduct = _getFromCache(url, moment());

            if (cachedProduct) {
                deferred.resolve(new Product(cachedProduct));
            } else {
                var p = new Product(productUid.product_id, productUid.colorId, null, null, productUid.sku);
                p.fetch()
                    .then(function (product) {
                        _addToCache(url, product, moment());
                        deferred.resolve(product);
                    })
                    .Catch(() => deferred.resolve(undefined));
            }

            return deferred.promise;
        }

        function _fetchProducts(productUidArray, amount) {
            let realAmount = amount;
            if (realAmount % 1 !== 0) {
                realAmount = Math.round(realAmount);
            }

            var deferred = $q.defer();

            if (!productUidArray || productUidArray.length === 0 || realAmount === 0) {
                deferred.resolve([]);
                return deferred.promise;
            }

            let productsToFetch = [];
            if (realAmount === -1) {
                productsToFetch = productUidArray;
                productUidArray = [];
            } else {
                const length = productUidArray.length;
                productsToFetch = productUidArray.slice(0, realAmount);
                productUidArray = productUidArray.slice(realAmount, length);
            }

            _fetchArrayProducts(productsToFetch).then((fetchedProducts) => {
                // TODO revisar fix despliegue r4
                var showNoStock = inditex.xconf.SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK;
                var enabledSoldOut = inditex.xconf.ENABLED_SOLD_OUT_410_PAGE === '1';

                fetchedProducts = _.filter(fetchedProducts, function (p) {
                    if (
                        (p.visibility === joyr.constants.visibility.HIDDEN_VISIBILITY ||
                            (p.visibility === joyr.constants.visibility.SOLD_OUT_VISIBILITY && showNoStock == 'HIDDEN')) &&
                        enabledSoldOut
                    ) {
                        return false;
                    }
                    if (p.gridElemType === 'MOCACO' || p.gridElemType === 'ESTILISMO') {
                        return p.bundleProductSummaries.length > 0;
                    } else {
                        return p.detail.colors.length > 0;
                    }
                });

                const noMoreToFindLeft = productUidArray.length === 0;
                const allNecessaryFetched = realAmount !== -1 && fetchedProducts.length === realAmount;

                if (noMoreToFindLeft || allNecessaryFetched) {
                    deferred.resolve(fetchedProducts);
                } else {
                    realAmount -= fetchedProducts.length;
                    _fetchProducts(productUidArray, realAmount).then((recursiveProducts) => {
                        const finalProducts = fetchedProducts.concat(recursiveProducts);
                        deferred.resolve(finalProducts);
                    });
                }
            });

            return deferred.promise;
        }

        /////////////////////////OLD

        // @Product<Product>
        // @ArrayExcludeProducts<any> Require .id
        // Return array
        function getProductsRecentlyViewed(product, arrayExcludeProducts) {
            var deferred = $q.defer();
            var state = getStateRecentlyViewed();
            var productsViewed = _cleanExpiredProducts(state).products;
            var arrayFiltered = _filteredArrayProducts(productsViewed, arrayExcludeProducts, product);

            deferred.resolve(_.sortBy(arrayFiltered, 'timestamp').reverse());

            logger.log('Product Related Service getProductRecentlyViewed :', _.sortBy(arrayFiltered, 'timestamp').reverse());
            return deferred.promise;
        }

        function setProductRecentlyViewed(product) {
            if (!product || (product && !product.id) || product.isBundleBean) {
                return;
            }
            var oldState = getStateRecentlyViewed();
            if (!oldState || (oldState && oldState.storeId != storeId)) {
                saveState(new NewState(), product);
            } else {
                saveState(_cleanExpiredProducts(oldState), product);
            }
        }

        // Extrae los productos relacionados con el producto que estamos viendo (Tipo Related buyed)
        function getProductBuyed(product, arrayExcludeProducts) {
            console.log('AQUI DOS');
            // Obtén el MOCACO del producto que estamos viendo
            var mocaco = product.getMocacocode();

            return $http
                .get('/relateds/related_buyed.json?ts=' + _this.ts)
                .then(function (res) {
                    var arrayProductsId;

                    try {
                        if (res.data[mocaco]) {
                            // Consruye un array de productos relaciondos a partir del JSON
                            arrayProductsId = res.data[mocaco].floren;
                        }
                    } catch (error) {
                        logger.logError(error);
                    }

                    // Genera un array de productos en formato "ProductUid" a partir de los productos relacionados
                    var array = _generateProductUidArray(arrayProductsId);

                    // Genera un array donde se han filtrado los productos exluídos
                    var arrayFiltered = _filteredArrayProducts(array, arrayExcludeProducts);

                    return arrayFiltered;
                })
                .catch(function () {
                    logger.logError('PRODUCTS RELATEDS GET STATIC FILE ERROR');
                });
        }

        // Extrae los productos relacionados con el producto que estamos viendo (Tipo Related)
        function getProductRelated(product, arrayExcludeProducts) {
            var mocaco = product.getMocacocode();
            return $http
                .get(_this.staticUrl + '/relateds/products_' + md5(mocaco).slice(-2) + '.json?ts=' + _this.ts)
                .then(function (res) {
                    var arrayProductsId;
                    try {
                        if (res.data[mocaco]) {
                            arrayProductsId = res.data[mocaco].similars;
                        }
                    } catch (error) {
                        logger.logError(error);
                    }
                    var array = _generateProductUidArray(arrayProductsId);

                    var arrayFiltered = _filteredArrayProducts(array, arrayExcludeProducts, product);

                    return arrayFiltered;
                })
                .catch(function () {
                    logger.logError('PRODUCTS RELATEDS GET STATIC FILE ERROR');
                });
        }

        function getCompleteLook(product, arrayExcludeProducts) {
            var mocaco = product.getMocacocode();
            return $http
                .get(_this.staticUrl + '/relateds/products_' + md5(mocaco).slice(-2) + '.json?ts=' + _this.ts)
                .then(function (res) {
                    var arrayCategories;
                    try {
                        if (res.data[mocaco]) {
                            arrayCategories = _.each(res.data[mocaco].recommendations, function (category) {
                                if (category && category.result[0]) {
                                    var array = _generateProductUidArray(category.result);
                                    category.filteredResult = _filteredArrayProducts(array, arrayExcludeProducts, product);
                                }
                            });
                        }
                    } catch (error) {
                        logger.logError(error);
                    }

                    return arrayCategories;
                })
                .catch(function () {
                    logger.logError('COMPLETE YOUR LOOK GET STATIC FILE ERROR');
                });
        }

        function openPopupRelateds(product, customized) {
            if (product) {
                ngDialog.open({
                    template:
                        '<itx-related-product-dialog product="ngDialogData.product" customized="ngDialogData.customized"></itx-related-product-dialog>',
                    plain: true,
                    className: 'ma-dialog new-modal hg-modal-md  ma-dialog-full hg-dialog-related-product ngdialog-theme-plain',
                    showClose: true,
                    data: {
                        product: product,
                        customized: customized
                    },
                    preCloseCallback: function () {
                        imDispatcherService.sortEvent('pageview', product);
                    }
                });
            }
        }

        // debe recibir un array de productos, y un array de mocacos
        // debemos filtrar los productos si tenemos el mocaco para excluir
        // arrayProducts = [ProductRelated]
        // arrayExclude = [item shopcart];
        function filterProductsByMocaco(arrayProducts, arrayExclude) {
            // Filtramos los productos recibidos por sku
            var x = _.filter(arrayProducts, function (product) {
                var search = true;
                _.each(arrayExclude, function (p) {
                    var productExlude = new ProductUid(p);
                    if (_.includes(product.arraySku, productExlude.sku)) {
                        search = false;
                        return;
                    }
                });
                return search;
            });
            return x;
        }

        // PRIVATE
        function saveState(state, product) {
            state.products = _cleanIdDuplicated(state.products, product);
            var products = _.concat(state.products.slice(-10), new ProductUid(product));
            state.products = products;
            setStateRecentlyViewed(state);
        }

        function getStateRecentlyViewed() {
            let isCookieGroupAllowed = CommonServices.isCookieGroupAllowed(cookieGroup);
            if (!isCookieGroupAllowed || !inditex.getLocalStorage(KEY)) {
                return new NewState();
            } else {
                return JSON.parse(inditex.getLocalStorage(KEY));
            }
        }

        function setStateRecentlyViewed(newState) {
            const isCookieGroupAllowed = CommonServices.isCookieGroupAllowed(cookieGroup);
            if (isCookieGroupAllowed) {
                inditex.setLocalStorage(KEY, JSON.stringify(newState));
            }
        }

        function _cleanExpiredProducts(state) {
            var numDaysBetween = function (d1, d2) {
                var diff = Math.abs(d1 - d2);
                return diff / (1000 * 60 * 60 * 24);
            };
            state.products = _.filter(state.products, function (p) {
                return numDaysBetween(p.timestamp, new Date().getTime()) < daysOfExpiration;
            });
            return state;
        }

        function _cleanIdDuplicated(arrayProducts, product) {
            return _.filter(arrayProducts, function (p) {
                return p.product_id != product.id;
            });
        }

        // array[<ProductRelated>]
        // arrayExclude[<Product || Mocaco>]
        // productExclude[<Product>]
        function _filteredArrayProducts(array, arrayExclude, productExclude) {
            // Comprueba que el array no esté vacío
            if (!array) {
                return [];
            }

            // Genera un array de productos excluidos
            var newArrayExclude = _generateProductUidArray(arrayExclude, productExclude);
            var keysExclude = _.keyBy(newArrayExclude, function (o) {
                return o.product_id;
            });
            return _.filter(array, function (obj) {
                return keysExclude[obj.product_id] === undefined;
            });
        }

        // Genera un array de productos en formato "ProductUid" a partir de los productos relacionados
        function _generateProductUidArray(array, product) {
            var result = [];
            if (product) {
                result.push(new ProductUid(product));
            }
            _.each(array, function (p) {
                if (p) {
                    result.push(new ProductUid(p));
                }
            });

            return result;
        }
    }
})();
